import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  Image: { content: <Skeleton height="70px" width="70px" />, center: true },
  "Connector Name": {
    content: <Skeleton height="20px" width="150px" />,
    center: false,
  },
  "MOP (kW)": {
    content: <Skeleton height="20px" width="50px" />,
    center: true,
  },
  "MCO (Amps)": {
    content: <Skeleton height="20px" width="50px" />,
    center: true,
  },
  "Charging level": {
    content: <Skeleton height="20px" width="100px" />,
    center: true,
  },
  "Current Type": {
    content: <Skeleton height="20px" width="50px" />,
    center: true,
  },
  Status: { content: <Skeleton height="20px" width="50px" />, center: true },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const ConnectorsSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default ConnectorsSkeleton
